'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import AjaxHandler class */
import AjaxHandler from '../../../shared/utility/ajax_handler/ajax_handler'

/**
 * @class LoginHandler
 */
class LoginHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        $('input[name="localTimeZone"]').val(Intl.DateTimeFormat().resolvedOptions().timeZone);
        this._listenLoginSubmit();
    }

    /**
     * login
     */
    _listenLoginSubmit ()
    {
        $("#ajax-login").on("click", function ()
        {
            let data = {
                username: $("#username").val(),
                password: $("#password").val(),
                localTimeZone: $("#localTimeZone").val()
            };

            AjaxHandler.post('user/login', data).then((response) =>
            {
                if (response.success)
                {
                    window.location.href = document.referrer;
                } else {
                    $('#customer-login-error').html('Pogrešan e-mail ili lozinka');
                }
            });
            return false;
        });
    }
}

/** Start LoginHandler */
$(document).ready(() => { new LoginHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/login.js